import React, { useState, useEffect } from "react";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function AdDetail() {
    const [shopDetail, setShopDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchApiData = async () => {
            const name = location.pathname.split("/").filter(Boolean).pop();
            const url = "api/adds/detail/" + name;
            const result = await fetchData(url);
            setLoading(false);
            // console.log(result.data)
            if (result && result.data) {
                setShopDetail(result.data);
            }
        };
        fetchApiData();
    }, [location.pathname]);

    return (
        <div className="container py-5">
            {loading ? (
                <MainLoader />
            ) : (
                <>
                    <div className="">
                        {/* Modern Header */}
                        <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                            <h1 className="display-4 fw-bold mb-2">Ad <span className="brand-name">Detail</span> </h1>
                            <p className="lead">Browse the latest ads, deals, and listings. Post your ad free and reach buyers fast.</p>

                        </div>
                    </div>
                    <div className="card p-4 border-0 shadow rounded-4">
                        <div className="row">
                            <div className="col-md-8 col-sm-12 col-12">
                                <div className="d-flex gap-2 flex-wrap">
                                    <h4 className="mb-3 text-primary">{shopDetail?.title}</h4>
                                    {shopDetail?.is_verified !== 0 && (
                                        <p className="bg-success small px-2 py-1 text-white rounded">Featured</p>
                                    )}
                                </div>
                                <p>{shopDetail?.short_description}</p>
                                <div className="row g-4 mt-3">
                                    {/* Pathname */}
                                    <InfoBlock icon="bi-link-45deg" label="Email" value={shopDetail?.email} />

                                    {/* Hash */}
                                    <InfoBlock icon="bi-hash" label="Address" value={shopDetail?.address} />

                                </div>
                            </div>
                            <div className="col-md-4 col-12 col-sm-12">
                                <img src={shopDetail.media[0]?.original_url} style={{ height: '16em', objectFit: 'contain' }} className="w-100" />
                            </div>
                        </div>


                        {/* Shop API Detail Section */}
                        <div className="mt-5">
                            <div className="row g-3">
                                <div className="col-md-12 mt-5">
                                    <div dangerouslySetInnerHTML={{ __html: shopDetail?.long_description }}></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

// Reusable InfoBlock component for router data
const InfoBlock = ({ icon, label, value }) => (
    <div className="col-md-6 d-flex align-items-center">
        <div
            className="me-3 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "50px", height: "50px" }}
        >
            <i className={`bi ${icon} fs-4`}></i>
        </div>
        <div>
            <h6 className="mb-0">{label}</h6>
            <p className="mb-0 text-muted">{value}</p>
        </div>
    </div>
);

export default AdDetail;
